module.exports = __webpack_public_path__ + "img/tickets-bg-mobile.5f871078.png";